import { c as _c } from "react/compiler-runtime";
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { youtubeEmbedURL } from '@/app/utils/video';
import type { ComponentNewsYoutube } from '@/types/tis-cms/types';
export const YouTubeContent = t0 => {
  const $ = _c(5);
  const {
    data,
    title
  } = t0;
  let t1;
  if ($[0] !== data.youtubeId) {
    t1 = data.youtubeId ? youtubeEmbedURL(data.youtubeId) : "";
    $[0] = data.youtubeId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const videoSrc = t1;
  if (!videoSrc) {
    return null;
  }
  const t2 = data.title || title;
  let t3;
  if ($[2] !== t2 || $[3] !== videoSrc) {
    t3 = <DetailsContentRow><div className="aspect-16-9 w-full"><iframe src={videoSrc} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} title={t2} className="size-full border-0" /></div></DetailsContentRow>;
    $[2] = t2;
    $[3] = videoSrc;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};